import {
    Alert, Avatar, Badge, Breadcrumb, Button,
    Card, Col, Collapse, DatePicker, Modal, Upload, Drawer,
    Dropdown, Flex, Form, Input, Layout, Menu, Popconfirm,
    Popover, Row, Select, Space, Table, Tabs, Tag, theme,
    Timeline, message, Divider, Checkbox, Radio, Image,
    notification
} from 'antd';
import { SortDescendingOutlined, DownOutlined, UploadOutlined, SettingOutlined, InfoCircleOutlined, FileTextOutlined, MoreOutlined, CheckCircleFilled, FilePdfOutlined, FileWordOutlined, DeleteOutlined, FileOutlined, FieldTimeOutlined, FileExclamationOutlined, InboxOutlined, EditOutlined, DownloadOutlined, FileJpgOutlined, SendOutlined, CloseCircleFilled, InfoCircleFilled, PlusOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import { Typography } from "antd";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import WorkflowManagementAPI from '../../../restAPI/WorkflowManagementAPI';
import { blue } from '@ant-design/colors';
import TextEditor from '../../../helperComponents/TextEditor';
import dayjs from "dayjs";

import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Inprogress from './Inprogress';
import Archived from './Archived';
import PaymentInvoice from '../ApprovalRequest/PaymentInvoice';
import { forEach } from 'lodash';


const { Search, TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title, Text } = Typography;
const { Dragger } = Upload;
const { Header, Footer, Sider, Content } = Layout;


export default function ViewCirculer() {

    const { token: { colorBorderSecondary, colorBorder, colorBgElevated, colorBgContainer, colorPrimaryBg, borderRadiusLG, colorError, colorPrimary, colorWarning, colorPrimaryBorderHover, colorText }, } = theme.useToken();

    const [actionForm] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [fileList2, setFileList2] = useState([]);
    const [count, setCount] = useState(0);
    const [count2, setCount2] = useState(0);
    const [commentBtnStatus, setCommentBtnStatus] = useState(true);


    const [levelList, setLevelList] = useState([]);
    const [actionButtontype, setActionButtonType] = useState(0);

    const { companyId, token, userId, userCompany } = useSelector(state => state.auth);
    const [currentCompanyInfo, setCurrentCompanyInfo] = useState({})

    const location = useLocation();
    //const { objectDataToFullCirculerView } = location.state || {};
    const { tabValue, approvalId } = location.state || {};
    //console.log(tabValue)
    //console.log(approvalId)
    const [objectDataToFullCirculerView, setObjectDataToFullCirculerView] = useState();
    const [isValueSet, setIsValueSet] = useState(false);
    const [stateChanged, setStateChanged] = useState();

    //Action Buttons
    const [isVisibleSaveButton, setIsVisibleSaveButton] = useState(true);
    const [isVisibleApproveButton, setIsVisibleApproveButton] = useState(true);
    const [isVisibleRejectButton, setIsVisibleRejectButton] = useState(true);
    const [needMoreInfoFieldsVisibility, setNeedMoreInfoFieldsVisibility] = useState(true);

    const [inputValue, setInputValue] = useState('');
    const [actionButtonName, setActionButtonName] = useState('');

    const inputRefs = useRef({});
    const [rows, setRows] = useState([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const showResponseDrawer = () => {
        setIsDrawerOpen(true);
    }

    const onCloseResponseDrawer = () => {
        setIsDrawerOpen(false);
    }

    const [open, setOpen] = useState(false);
    const hide = () => {
        setOpen(false);
    };

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };

    const [drawerVisible, setDrawerVisible] = useState(false); // Drawer control
    //const { token: { colorBgContainer, borderRadiusLG, colorError }, } = theme.useToken();
    const onChange = (key) => {
        ////console.log(key);
    };

    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1); // Navigate to the previous page
    };

    useEffect(() => {
        //checkUserRole(objectDataToFullCirculerView);
        const companyInfo = userCompany.companyData.find(company => company.companyId === companyId);
        setCurrentCompanyInfo(companyInfo);
    }, [companyId]);

    useEffect(() => {
        //console.log(tabValue)
        if (tabValue == 1) {
            getToDoData()
        } else {
            getApprovalRequestsData()
        }
    }, [1, stateChanged])

    const getToDoData = async () => {
        var userRole = 0;
        const companyInfo = userCompany.companyData.find(company => company.companyId === companyId);
        await WorkflowManagementAPI.getToDoRequests(companyId, token).then((res) => {
            setCurrentCompanyInfo(companyInfo);

            var dataList = res.data
            dataList.forEach(element => {
                let changeDate = new Date(element['createdAt']).toLocaleString()
                element['createdAt'] = changeDate
                element['approvers'].forEach(elementApprover => {

                    if (elementApprover['approverResponseTime'] != null) {
                        let changeDateApprover = new Date(elementApprover['approverResponseTime']).toLocaleString()
                        elementApprover['approverResponseTime'] = changeDateApprover
                    }
                });

                //debugger
                if (companyInfo['userDetailsId'] == element['createdBy']['_id']) {//Initiator
                    if (element['permission'] == 'approve') {
                        userRole = 2; //Approver
                    } else {
                        userRole = 1;
                    }
                }
                else {
                    if (getApproverIdMatchingParentID(element['parentEntryId'], element['approvers'])) {
                        userRole = 2; //Approver
                    } else {
                        userRole = 3; //Viewer
                    }
                }
                element["userRole"] = userRole;
                element["tabKey"] = 2; //InProgress
            });

            for (var obj of dataList) {
                if (obj._id == approvalId) {
                    setObjectDataToFullCirculerView(obj)
                    setIsValueSet(true)
                    checkUserRole(obj);
                }
            }
        }).catch((err) => {
            console.log("Error getting ApprovalRequestsData :", err.message);
        }).finally(() => {

        })
    };

    const getApprovalRequestsData = async () => {
        var userRole = 0;
        const companyInfo = userCompany.companyData.find(company => company.companyId === companyId);
        await WorkflowManagementAPI.getApprovalRequests(1, companyId, token).then((res) => {
            setCurrentCompanyInfo(companyInfo);

            var dataList = res.data
            dataList.forEach(element => {
                let changeDate = new Date(element['createdAt']).toLocaleString()
                element['createdAt'] = changeDate
                element['approvers'].forEach(elementApprover => {

                    if (elementApprover['approverResponseTime'] != null) {
                        let changeDateApprover = new Date(elementApprover['approverResponseTime']).toLocaleString()
                        elementApprover['approverResponseTime'] = changeDateApprover
                    }

                    if (elementApprover['hockResponseTime'] != null) {
                        let changeDateApprover = new Date(elementApprover['hockResponseTime']).toLocaleString()
                        elementApprover['hockResponseTime'] = changeDateApprover
                    }
                });

                if (companyInfo['userDetailsId'] == element['createdBy']['_id']) {
                    userRole = 1;   //Initiator
                }
                else {
                    if (getApproverIdMatchingParentID(element['parentEntryId'], element['approvers'])) {
                        userRole = 2; //Approver
                    } else {
                        userRole = 3; //Viewer
                    }
                }

                //userRole = 1
                element["userRole"] = userRole;
                element["tabKey"] = 1;
            });

            for (var obj of dataList) {
                if (obj._id == approvalId) {
                    setObjectDataToFullCirculerView(obj)
                    setIsValueSet(true)
                    checkUserRole(obj);
                }
            }
        }).catch((err) => {
            console.log("Error getting ApprovalRequestsData :", err.message);
        }).finally(() => {

        })
    };

    function getApproverIdMatchingParentID(param1, list) {
        for (const element of list) {
            if (element['_id'] == param1) {
                if (element['permission'] == 'view') {
                    return false
                }
            }
        }
        return true
    }

    const handleMenuClick = ({ key }) => {
        switch (key) {
            case 'print':
                //console.log('Print Comments & Status clicked');
                // Implement print functionality here
                break;
            case 'needMoreInfo':
                setOpen(true); // Opens the existing popover
                break;
            case 'checkPriority':
                setDrawerVisible(true);
                break;
            default:
            //console.log('Unhandled menu action');
        }
    };

    function setMenuProps(data) {
        var type = false;

        if (data.tabKey == 1) { //In Progress
            type = true
        }

        const items = [
            {
                label: 'Print Comments & Status',
                key: 'print',
                icon: <DownloadOutlined />,
                disabled: type,
            },
            // {
            //     label: 'Need More Info',
            //     key: 'needMoreInfo',
            //     icon: <InfoCircleOutlined />,

            // },
            {
                label: 'Check Priority Order',
                key: 'checkPriority',
                icon: <SortDescendingOutlined />,
            },
        ];


        const menuProps = {
            items,
            onClick: handleMenuClick,
        };

        return menuProps
    }

    const columns = [
        {
            title: 'Primary Approver',
            dataIndex: ['approver', 'name'],
            //key: 'initiator',
            render: (_, record) => (
                <Flex align='center' gap={16}>
                    <Avatar style={{ backgroundColor: colorPrimary, }}>
                        {record.approver.name.charAt(0).toUpperCase()}
                    </Avatar>
                    {record.approver.name}
                    {record.iconApprover != '' && (
                        <record.iconApprover style={{ color: setActionTypeColor(record.approverStatus), fontSize: "16px" }} />
                    )}
                </Flex>
            ),
        },
        {
            title: 'Alternate Signatory',
            dataIndex: ['hockUser', 'name'],
            render: (_, record) => (
                <>
                    {record.hockUser != null && (
                        <Flex align='center' gap={16}>
                            <Avatar style={{ backgroundColor: colorWarning, }}>
                                {record.hockUser.name.charAt(0).toUpperCase()}
                            </Avatar>
                            {record.hockUser.name}
                            {record.iconHoc != '' && (
                                <record.iconHoc style={{ color: setActionTypeColor(record.hockUserStatus), fontSize: "16px" }} />
                            )}
                        </Flex>
                    )}
                </>

            ),
        },
        {
            title: 'Status',
            dataIndex: 'approverStatus',
            key: 'approverStatus',
            align: 'center',
            width: 200,
            render: (_, record) => (
                <Space size="middle">
                    <span
                        style={{
                            backgroundColor: setActionStatusColor(record.approverStatus, record.hockUserStatus),
                            paddingLeft: 8,
                            paddingRight: 8,
                            paddingTop: 4,
                            paddingBottom: 4,
                            borderRadius: borderRadiusLG,
                            color: "white",
                        }}
                    >
                        <Text>{setActionStatusName(record.approverStatus, record.hockUserStatus)}</Text>
                    </span>
                </Space>
            ),
        },
    ];

    function showApproverStatusIcon(param1, param2) {
        if (param1 == 'pending' && param2 == 'pending') {
            return '';
        }

        if (param1 == 'approved' || param1 == 'rejected' || param1 == 'needMoreInfo') {
            if (param1 === 'approved') {
                return CheckCircleFilled
            } else if (param1 === 'rejected') {
                return CloseCircleFilled
            } else if (param1 === 'needMoreInfo') {
                return InfoCircleFilled
            }
        }
        else {
            return '';
        }
    }

    function showHocStatusIcon(param1, param2) {
        if (param1 == 'pending' && param2 == 'pending') {
            return '';
        }

        if (param2 == 'approved' || param2 == 'rejected' || param2 == 'needMoreInfo') {
            if (param2 === 'approved') {
                return CheckCircleFilled
            } else if (param2 === 'rejected') {
                return CloseCircleFilled
            } else if (param2 === 'needMoreInfo') {
                return InfoCircleFilled
            }
        }
        else {
            return '';
        }
    }

    function setActionTypeColor(data) {
        ////console.log(data)
        if (data === 'pending') {
            return colorWarning
        } else if (data === 'approved') {
            return colorPrimary
        } else if (data === 'rejected') {
            return colorError
        } else if (data === 'needMoreInfo') {
            return 'blue'
        }
    }

    function setActionStatusName(param1, param2) {
        //console.log(param2)
        if (param1 === 'needMoreInfo') {
            param1 = 'Need More Info'
        } else if (param2 === 'needMoreInfo') {
            param2 = 'Need More Info'
        }

        if (param1 === 'pending' && param2 === 'pending') {
            return 'Pending'
        } else if ((param1 === 'pending' || param1 == null)) {
            return param2.charAt(0).toUpperCase() + param2.slice(1);
        } else if ((param2 === 'pending' || param2 == null)) {
            return param1.charAt(0).toUpperCase() + param1.slice(1);
        }
    }

    function setActionStatusColor(param1, param2) {
        if (param1 === 'pending' && param2 === 'pending') {
            return colorWarning
        } else if ((param1 === 'pending' || param1 == null)) {
            if (param2 === 'approved') {
                return colorPrimary
            } else if (param2 === 'rejected') {
                return colorError
            } else if (param2 === 'needMoreInfo') {
                return 'blue'
            }
        } else if ((param2 === 'pending' || param2 == null)) {
            if (param1 === 'approved') {
                return colorPrimary
            } else if (param1 === 'rejected') {
                return colorError
            } else if (param1 === 'needMoreInfo') {
                return 'blue'
            }
        }
    }

    function setActionStatusIcon() {
        var objList = []
        var objectData = objectDataToFullCirculerView.approvers;

        for (var element of objectData) {

            if (element.permission != 'view') {
                element["iconApprover"] = showApproverStatusIcon(element.approverStatus, element.hockUserStatus)
                element["iconHoc"] = showHocStatusIcon(element.approverStatus, element.hockUserStatus)

                objList.push(element)
            }
        };
        ////console.log(objList)
        return objList
    }

    function checkUserRole(data) {
        ////console.log(data)
        if (data['userRole'] == 1) {
            setIsVisibleSaveButton(false)
            setIsVisibleApproveButton(false)
            setIsVisibleRejectButton(false)
        } else if (data['userRole'] == 2) {
            setIsVisibleSaveButton(false)
            setIsVisibleApproveButton(true)
            setIsVisibleRejectButton(true)
        } else if (data['userRole'] == 3) {
            setIsVisibleSaveButton(false)
            setIsVisibleApproveButton(false)
            setIsVisibleRejectButton(false)
        }

        if (data['tabKey'] == 1) { //To Do
            setIsVisibleSaveButton(false)
            setIsVisibleApproveButton(false)
            setIsVisibleRejectButton(false)
        }
    }

    function setDocumentsIcons(data) {

        const myArray = data['name'].split(".");
        var extensionToLower = myArray[1].toLowerCase();

        if (extensionToLower == 'png') {
            return '<FileJpgOutlined />'
        } else if (extensionToLower == 'pdf') {
            return '<FilePdfOutlined />'
        }
        else if (extensionToLower == 'sdasd') {
            return '<FileWordOutlined />'
        } else {
            return '<FileWordOutlined />'
        }
    }

    const content = (
        <Form layout="vertical" style={{ maxWidth: 300 }}>
            <Text type='secondary'>If you need more info, select level or user and add your comment and request details:</Text>
            <Form.Item label="Select Level">
                <Select placeholder="Select a level or user">
                    <Select.Option value="level1">Level 1</Select.Option>
                    <Select.Option value="level2">Level 2</Select.Option>
                    <Select.Option value="user1">User 1</Select.Option>
                </Select>
            </Form.Item>
            <Form.Item label="Add Comment">
                <TextArea rows={3} placeholder="Enter your comment here" />
            </Form.Item>
            <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={hide}>Cancel</Button>
                <Button type="primary" onClick={hide}>Send</Button>
            </Space>
        </Form>
    );

    async function submitComments() {
        setStateChanged(false)
        const formData = new FormData();
        if (fileList.length > 0) {
            for (let i = 0; i < fileList.length; i++) {
                formData.append("files", fileList[i].file);
            }
        } else {
            formData.append("files", null);

        }
        formData.append("comment", inputValue);

        formData.append("commentType", "normal");

        try {
            await WorkflowManagementAPI.postComments(objectDataToFullCirculerView._id, companyId, token, formData).then((res) => {
                //navigate('/work-flow/circuler');
                setStateChanged(true)
            })
        } catch (err) {
            ////console.log(err.message)
            openNotification('error', 'Error', `This circulation is now closed, and no further action will be considered.`, 'bottomLeft');

            // messageApi.open({
            //     type: 'error',
            //     content: 'This circulation is now closed, and no further action will be considered.',
            // });
        }
    }

    const setInputFieldValue = (e) => {
        if (e.target.value.length <= 0) {
            setCommentBtnStatus(true)
        } else {
            setCommentBtnStatus(false);
        }
        setInputValue(e.target.value);
        ////console.log(e.target.value)
    }

    ////////----------------------------------------------------Handle Buttons ----------------------------------------------------------
    async function onClickApproveButton(data) {
        setNeedMoreInfoFieldsVisibility(true)
        //showModal()
        setIsDrawerOpen(true)
        setActionButtonType(1)
        setActionButtonName('Approve')
    }

    async function onClickRejectButton(data) {
        setNeedMoreInfoFieldsVisibility(true)
        //showModal()
        setIsDrawerOpen(true)
        setActionButtonType(2)
        setActionButtonName('Reject')
    }

    async function onClickNeedMoreInfoButton(data) {

        var listOfObjects = [];

        var response = await WorkflowManagementAPI.getUserLevelList(objectDataToFullCirculerView._id, objectDataToFullCirculerView.parentEntryId, companyId, token).then((res) => {
            return res.data;
        })

        for (let i = 0; i < response.length; i++) {
            listOfObjects.push(
                setLevelListData(
                    i,
                    response[i]['approver']['name'],
                    response[i]['_id'],
                )
            )
        }
        setLevelList(listOfObjects)

        setNeedMoreInfoFieldsVisibility(false)
        //showModal()
        setIsDrawerOpen(true)
        setActionButtonType(3)
        setActionButtonName('Send')
    }

    function setLevelListData(id, label, value) {

        return {
            id,
            label,
            value,
        };
    }

    const onFinish = async (values) => {
        ////console.log('actionForm')
        if (values.comment == undefined) {
            values.comment = ''
        }

        var formData = {};

        if (actionButtontype == 1) {
            formData = {
                "response": "approve",
                "comment": values.comment,
            }

            if (values.comment != '') {
                const formDataPass = new FormData();
                if (fileList2.length > 0) {
                    for (let i = 0; i < fileList2.length; i++) {
                        formDataPass.append("files", fileList2[i].file);
                    }
                } else {
                    formDataPass.append("files", null);

                }
                formDataPass.append("comment", values.comment);

                formDataPass.append("commentType", "approved");

                await WorkflowManagementAPI.postComments(objectDataToFullCirculerView._id, companyId, token, formDataPass).then((res) => {
                    ////console.log(res)
                })
            }
        }
        else if (actionButtontype == 2) {
            formData = {
                "response": "reject",
                "comment": values.comment,
            }

            if (values.comment != '') {
                const formDataPass = new FormData();
                if (fileList2.length > 0) {
                    for (let i = 0; i < fileList2.length; i++) {
                        formDataPass.append("files", fileList2[i].file);
                    }
                } else {
                    formDataPass.append("files", null);

                }
                formDataPass.append("comment", values.comment);

                formDataPass.append("commentType", "rejected");

                await WorkflowManagementAPI.postComments(objectDataToFullCirculerView._id, companyId, token, formDataPass).then((res) => {
                    ////console.log(res)
                })
            }
        }

        else if (actionButtontype == 3) {
            formData = {
                "response": "needMoreInfo",
                "comment": values.comment,
                "targetApproverEntryId": values.targetApproverEntryId
            }
        }

        var res = await WorkflowManagementAPI.approve(objectDataToFullCirculerView._id, objectDataToFullCirculerView.parentEntryId, companyId, token, formData).then((res) => {
            //console.log(res)
        })
        setActionButtonType(0)
        setIsDrawerOpen(false)
        //handleCancel()

        navigate('/work-flow/circuler')
    };

    function manageCommentType(data) {
        ////console.log(data)
        if (data === 'approved') {
            return 'Approved'
        }
        else if (data === 'rejected') {
            return 'Rejected'
        }
        else if (data === 'needMoreInfo') {
            return 'Need More Info'
        }
    }

    function manageCommentTypeColor(data) {
        if (data === 'approved') {
            return 'green'
        }
        else if (data === 'rejected') {
            return 'red'
        }
        else if (data === 'needMoreInfo') {
            return 'blue'
        }
    }

    function manageActionType(data) {
        ////console.log(data)

        if (data === 'approved') {
            return 'Approved'
        }
        else if (data === 'rejected') {
            return 'Rejected'
        }
        else if (data === 'needMoreInfo') {
            return 'Need More Info'
        }
        else if (data === 'pending') {
            return 'Pending'
        }
    }

    function setDocumentListData(id, label, value) {

        return {
            id,
            label,
            value,
        };
    }

    const generateHTML = (data) => {
        if (data != null || data != []) {
            try {
                const obj = JSON.parse(data);
                return obj.map((item, index) => {
                    const { id, fields } = item;
                    return (
                        <div key={id} className={`item-${id}`}>
                            {renderRow(item)}
                        </div>
                    );
                });
            } catch (error) {
                return <>{data}</>
            }
        } else {
            return <></>
        }
    };

    const setCommentDateTime = (param1, param2, isUpdate) => {

        if (isUpdate) {
            const date = new Date(param2);
            return date.toLocaleString();
        } else {
            const date = new Date(param1);
            return date.toLocaleString();
        }
    }

    const props = {
        name: "file",
        multiple: true,
        beforeUpload(file) {
            if (file.type !== "application/pdf") {
                // message.error("only PDF files are allowed.");
                openNotification('error', 'Error', `only PDF files are allowed.`, 'bottomLeft');

                return false;
            }
            let date = new Date().toISOString().split('T')[0];
            const obj = {
                key: count,
                name: file.name,
                file: file,
                added: date
            };
            setFileList((prev) => [...prev, obj]);
            setCount(count + 1);
            // message.success(`${file.name} added to the list.`);
            openNotification('success', 'Success', `${file.name} added to the list.`, 'bottomLeft');
            return false;
        },
        onRemove(file) {
            setFileList((prev) => prev.filter((item) => item.key !== file.key));
            setCount(count - 1);
            // message.info(`${file.name} removed.`);
            openNotification('info', 'Info', `${file.name}removed.`, 'bottomLeft');
        },
        onDrop(e) {
        },
    };



    const renderRow = (row, index) => {
        const columns = [];
        const columnCount = row.type === '1' ? 1 : row.type === '2' ? 2 : 3;
        const span = 24 / columnCount;

        const fields = row.fields;

        for (let i = 0; i < columnCount; i++) {
            const cellId = `${row.id}-${i}`;

            columns.push(
                <Col
                    key={cellId}
                    span={span}
                >
                    {fields.length !== 0 ?
                        <>
                            {fields.map((item, index) => {
                                if (cellId === item.cellId) {
                                    return getdropcontent(item, row.id)
                                }

                            })}
                        </> :
                        <>
                        </>

                    }

                </Col>
            );
        }

        return (
            <div
                key={row.id}
                id={row.id}
            >
                <Row style={{ marginBottom: '16px', position: 'relative' }}>
                    {columns}
                </Row>
            </div>
        );
    };

    const renderImageUploader = (item, row) => {
        var imageList = item['filelist']
        return (
            <>
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    {imageList.map((image, index) => (
                        <Image key={index} width={150} src={image.image} />
                    ))}
                </div>
            </>
        );
    };

    const getdropcontent = (item, row) => {
        let dropcontent = <></>
        dropcontent = (item.content === 'TextEditor') ? (
            <>
                <div dangerouslySetInnerHTML={{ __html: item.value }} />
            </>
        ) : (item.content === 'Title') ? (
            <>
                <div dangerouslySetInnerHTML={{ __html: item.value }} />
            </>
        ) : item.content === 'DateField' ? (
            <>
                <div dangerouslySetInnerHTML={{ __html: dayjs(item.value) }} />
            </>
        ) : item.content === 'ImageUploader' ? (
            renderImageUploader(item, row)
        ) : item.content === 'Signature' ? (
            renderImageUploader(item, row)
        ) : item.content === 'Divider' ? (
            <Divider />
        ) : item.content === 'CheckGroup' ? (
            <>
                <Checkbox.Group value={item.value}>
                    {item.options.map((option) => (
                        <>
                            {!option.disabled ?
                                <Flex align='center' gap={16} justify='flex-start' style={{ marginBottom: 8, width: '100%' }}>
                                    <Checkbox disabled={true} key={option.id} value={option.id}>{option.value}</Checkbox>
                                </Flex>
                                : <></>
                            }
                        </>

                    ))}
                </Checkbox.Group>
            </>

        ) : item.content === 'RadioGroup' ? (
            <>
                <Radio.Group style={{ width: '100%' }} value={item.value}>
                    {item.options.map((option) => (
                        <>
                            {!option.disabled ?
                                <Flex align='center' gap={16} justify='flex-start' style={{ marginBottom: 8 }}>
                                    <Radio disabled={option.disabled} key={option.id} value={option.id} >{option.value}</Radio>
                                    {/* <div dangerouslySetInnerHTML={{ __html: dayjs(item.value) }} /> */}
                                </Flex>
                                : <></>
                            }
                        </>

                    ))}
                </Radio.Group>
            </>
        ) : item.content === 'SelectGroup' ? (
            <>
                <Select style={{ width: '100%' }} value={item.value}>
                    {item.options.map((option) => (
                        <>
                            {!option.disabled ?
                                <Option key={option.id} value={option.id}>{option.value}</Option>
                                : <></>
                            }
                        </>
                    ))}
                </Select>
            </>
        ) : null
        return dropcontent;
    }

    const props2 = {
        name: "file",
        multiple: true,
        beforeUpload(file) {
            if (file.type !== "application/pdf") {
                // message.error("only PDF files are allowed.");
                openNotification('error', 'Error', `only PDF files are allowed.`, 'bottomLeft');
                return false;
            }
            let date = new Date().toISOString().split('T')[0];
            const obj = {
                key: count2,
                name: file.name,
                file: file,
                added: date
            };
            setFileList2((prev) => [...prev, obj]);
            setCount2(count2 + 1);
            // message.success(`${file.name} added to the list.`);
            openNotification('success', 'Success', `${file.name} added to the list.`, 'bottomLeft');
            return false;
        },
        onRemove(file) {
            setFileList2((prev) => prev.filter((item) => item.key !== file.key));
            setCount2(count2 - 1);
            // message.info(`${file.name} removed.`);
            openNotification('info', 'Info', `${file.name}removed.`, 'bottomLeft');

        },
        onDrop(e) {
            ////console.log("Dropped files:", e.dataTransfer.files);
        },
    };

    const singleDownloadHandler = async (item) => {
        try {
            const result = await WorkflowManagementAPI.downloadSingleFile(
                objectDataToFullCirculerView._id,
                item._id,
                companyId,
                token
            );

            const blob = new Blob([result], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = item.name || 'document'; // Use item.name or default to 'document'

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(link.href); // Cleanup
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };

    const bulkDownload = async (item) => {
        try {
            const result = await WorkflowManagementAPI.downloadAllFiles(item._id, companyId, token);

            const blob = new Blob([result], { type: 'application/zip' }); // Assuming it's a ZIP
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${item.subject}.zip` || `AllFiles.zip`; // Default filename if none provided

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(link.href); // Free up memory
        } catch (error) {
            console.error('Error during bulk download:', error);
        }
    };

    return (
        <>
            <>{contextHolder}</>
            {/* {objectDataToFullCirculerView != undefined || objectDataToFullCirculerView != null && ( */}
            {isValueSet == true && (
                <>

                    <Flex gap={20} justify='space-between' align='center' style={{
                        margin: '16px',
                        padding: '16px 24px',
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG,
                    }}>
                        <Breadcrumb
                            items={[
                                {
                                    href: '',
                                    title: <FileWordOutlined />,
                                },
                                {
                                    title: 'Workflow',
                                },
                                {
                                    href: goBack,
                                    title: 'View',
                                    onClick: goBack
                                },
                                {
                                    title: 'View Circulation',
                                },
                            ]}
                        />
                    </Flex>

                    <div style={{
                        margin: '16px',
                    }}>
                        { }
                    </div>

                    <Card
                        bordered={false}
                        style={{
                            margin: '16px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                    >
                        <span style={{ fontWeight: 600 }}> {objectDataToFullCirculerView.subject} </span>
                    </Card>

                    <Card
                        bordered={false}
                        style={{
                            margin: '16px',
                            // padding: 24,
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                    >


                        <Row gutter={16}>
                            <Col span={12}>
                                <Flex align='center' justify='flex-start' gap={16}>
                                    <Text strong>Requested Time : </Text>
                                    <Text >{objectDataToFullCirculerView.createdAt}</Text>
                                </Flex>
                            </Col>
                            <Col span={12}>
                                <Flex align='center' justify='flex-start' gap={16}>
                                    <Text strong>Requester Name : </Text>
                                    <Text >{objectDataToFullCirculerView.createdBy.name}</Text>
                                </Flex>
                            </Col>
                        </Row>
                        <div style={{ height: 12 }}></div>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Flex align='center' justify='flex-start' gap={16}>
                                    <Text strong>Request Type : </Text>
                                    <Text> {objectDataToFullCirculerView.requestType.requestType} </Text>
                                </Flex>
                            </Col>
                            <Col span={12}>
                                <Flex align='center' justify='flex-start' gap={16}>
                                    <Text strong>Number of Participants : {objectDataToFullCirculerView.approvers.length}</Text>
                                    <Text >{ }</Text>
                                </Flex>
                            </Col>

                        </Row>

                    </Card>

                    <Card
                        bordered={false}
                        style={{
                            margin: '16px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                        title="Message"
                    >
                        <Row gutter={16}>
                            <Col span={24}>

                                <Text >{objectDataToFullCirculerView.message}</Text>
                            </Col>

                        </Row>
                    </Card>

                    <Card
                        bordered={false}
                        style={{
                            margin: '16px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                        title="Approval Request"
                    >
                        <Row gutter={16}>
                            <Col span={24}>
                                <>
                                    {generateHTML(objectDataToFullCirculerView.template)}
                                </>

                            </Col>
                        </Row>
                    </Card>

                    <Card
                        bordered={false}
                        style={{
                            margin: '16px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                        title="Support Document"
                        extra={
                            objectDataToFullCirculerView.documents.length !== 0 && (
                                <Button
                                    type='link'
                                    icon={<DownloadOutlined />}
                                    onClick={(e) => {
                                        bulkDownload(objectDataToFullCirculerView)
                                    }}
                                >
                                    Download All
                                </Button>
                            )
                        }
                    >
                        <Flex vertical gap={8}>
                            {
                                objectDataToFullCirculerView['documents'].map((item, index) => (
                                    <Flex key={index} align='center' justify='space-between' gap={16}>
                                        <Flex align='center' gap={16}>
                                            <Avatar size={48} icon={<FilePdfOutlined />} style={{ backgroundColor: colorPrimary, cursor: 'pointer' }} onClick={() => window.open(item.path, '_blank')} />
                                            <Text style={{ cursor: 'pointer' }} onClick={() => window.open(item.path, '_blank')}>{item.name.split('.').slice(0, -1).join('.')}</Text>
                                        </Flex>
                                        <Button
                                            onClick={(e) => {
                                                singleDownloadHandler(item)
                                            }}
                                            type='link' icon={<DownloadOutlined />} />
                                    </Flex>
                                ))
                            }
                        </Flex>

                    </Card>

                    <Card
                        bordered={false}
                        style={{
                            margin: '16px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                        title="Approvers"
                    >

                        <Flex vertical gap={12}>
                            {objectDataToFullCirculerView['approvers'].map((item, index) => (
                                <>
                                    <Flex
                                        gap={8} align='center' justify='space-between'
                                        style={{
                                            border: `1px solid ${colorBorderSecondary}`,
                                            padding: 16,
                                            borderRadius: borderRadiusLG,
                                            backgroundColor: colorBgElevated
                                        }}>
                                    </Flex>
                                </>
                            ))}
                        </Flex>

                        <Table
                            dataSource={setActionStatusIcon()}
                            columns={columns}
                            pagination={false} />
                    </Card>

                    <Card
                        bordered={false}
                        style={{
                            margin: '16px',
                            // padding: 24,
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                        title="Add Comment"
                    // extra={<a href="#">More</a>}
                    >
                        <Row>
                            <Col span={24}>
                                <Form layout="vertical">
                                    <Form.Item>
                                        <Input placeholder="Add your Comment" onChange={setInputFieldValue} />
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <div>
                                    <Dragger {...props} fileList={fileList}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <Text type='secondary' className="ant-upload-text">Click or drag file to this area to upload</Text>
                                        <br />
                                        <Text type='secondary' className="ant-upload-hint">
                                            Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                                            banned files.
                                        </Text>
                                    </Dragger>
                                </div>
                                <Flex align='center' justify='flex-end'>
                                    <Button disabled={commentBtnStatus} onClick={() => submitComments()} type='primary' style={{ marginTop: 16 }} icon={<SendOutlined />}>Send</Button>
                                </Flex>
                            </Col>
                        </Row>
                    </Card>

                    <div style={{
                        margin: '16px',
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG,
                        marginBottom: 80
                    }}>
                        <Collapse ghost bordered={false} size="large">
                            <Collapse.Panel
                                key="1"
                                header={
                                    <Flex align="center" gap={8}>
                                        <Badge count={objectDataToFullCirculerView['comments'].length} style={{ backgroundColor: colorPrimary }} />
                                        <span>Comments Left</span>
                                    </Flex>
                                }
                            >
                                <Flex gap={16} vertical>
                                    <Timeline>
                                        {objectDataToFullCirculerView['comments'].map((item, index) => (
                                            <Timeline.Item
                                                key={index}>
                                                <>
                                                    <Flex vertical gap={4} style={{ paddingBottom: 20 }}>
                                                        <Flex align='center' gap={16}>
                                                            <Flex align='center' justify='space-between' gap={16}>
                                                                <Text>{item.commentType == 'needMoreInfo' ? item.subject : item.commentedBy['name']}</Text>
                                                                <Text type='secondary' style={{ fontSize: 12 }}>{item.isUpdate ? (setCommentDateTime(item['createdAt'], item['updatedAt'], item.isUpdate)) : (setCommentDateTime(item['createdAt'], item['updatedAt'], item.isUpdate))}</Text>
                                                            </Flex>
                                                            <Tag style={{ display: item.commentType != 'normal' ? 'inline-block' : 'none' }} color={manageCommentTypeColor(item.commentType)} > {manageCommentType(item.commentType)} </Tag>
                                                        </Flex>
                                                        <Flex>
                                                            <Text type='secondary'>{item.comment}</Text>
                                                        </Flex>

                                                        {item.documents != 0 && (
                                                            <Flex vertical gap={4}>
                                                                {item['documents'].map((doc, indexDoc) => (
                                                                    <Flex key={indexDoc} gap={8} align='center' style={{ cursor: 'pointer' }}>
                                                                        <Avatar size={28} icon={<FilePdfOutlined />} style={{ backgroundColor: colorWarning }} />
                                                                        <Text style={{ cursor: 'pointer' }} onClick={() => window.open(doc.path, '_blank')} type='secondary'>{doc['name']}</Text>
                                                                    </Flex>
                                                                ))}
                                                            </Flex>
                                                        )}
                                                        {/* <Text type='secondary' style={{ fontSize: 12 }}> - {item.isUpdate ? ('Edited - ' + Date(item['updatedAt'])) : ('Created - ' + item['createdAt'].toLocaleString())}</Text> */}
                                                        {/* <Text type='secondary' style={{ fontSize: 12 }}>{item.isUpdate ? (setCommentDateTime(item['createdAt'], item['updatedAt'], item.isUpdate)) : (setCommentDateTime(item['createdAt'], item['updatedAt'], item.isUpdate))}</Text> */}
                                                    </Flex>
                                                </>
                                            </Timeline.Item>
                                        ))}
                                    </Timeline>
                                </Flex>
                            </Collapse.Panel>
                        </Collapse>
                    </div>

                    <Flex justify='space-between' align='center' style={{
                        width: 'calc(100% - 80px)',
                        paddingLeft: 8,
                        paddingRight: 12,
                        paddingTop: 16,
                        paddingBottom: 16,
                        borderTop: `1px solid ${colorBorder}`,
                        backgroundColor: colorBgElevated,
                        position: 'absolute',
                        bottom: 0,

                    }}>
                        <div><Text>Let us know your decision</Text></div>
                        <Flex justify="flex-end" align="center" gap={16}>
                            <Popover
                                content={content}
                                title="Do You Need More Info?"
                                trigger="click"
                                open={open}
                                onOpenChange={(newOpen) => setOpen(newOpen)} // Keeps popover under control
                            />
                            <Dropdown menu={setMenuProps(objectDataToFullCirculerView)}>
                                <Button>
                                    Actions
                                    <MoreOutlined />
                                </Button>
                            </Dropdown>

                            {isVisibleRejectButton && (
                                <Button
                                    onClick={() => onClickNeedMoreInfoButton(objectDataToFullCirculerView)}
                                    style={{ backgroundColor: blue }}
                                >
                                    Need info ?
                                </Button>
                            )}
                            {isVisibleApproveButton && (
                                <Button
                                    onClick={() => onClickApproveButton(objectDataToFullCirculerView)}
                                    type="primary"
                                >
                                    Approve
                                </Button>
                            )}
                            {isVisibleRejectButton && (
                                <Button
                                    onClick={() => onClickRejectButton(objectDataToFullCirculerView)}
                                    type="primary"
                                    danger
                                >
                                    Reject
                                </Button>
                            )}
                        </Flex>
                    </Flex>

                    <Drawer
                        title="Priority Order Details"
                        placement="right"
                        closable
                        onClose={() => setDrawerVisible(false)}
                        visible={drawerVisible}
                    >
                        <Timeline>
                            {objectDataToFullCirculerView['approvers'].map((item, index) => (
                                <Timeline.Item key={index}>
                                    <Text>{item.approver.name}</Text>
                                    <Flex align='center' justify='flex-start' gap={16}>
                                        <Text type='secondary'>{item.approverResponseTime}</Text>
                                        <Tag color="success">{manageActionType(item.approverStatus)}</Tag>
                                    </Flex>
                                </Timeline.Item>
                            ))}
                        </Timeline>
                    </Drawer>

                    <>
                        <Drawer
                            title={
                                actionButtonName === 'Send' ? 'Need More Information ?' :
                                    actionButtonName === 'Approve' ? 'Approve Circuler' :
                                        actionButtonName === 'Reject' ? 'Reject Circuler' :
                                            'Comment'  // default title
                            }
                            onClose={onCloseResponseDrawer}
                            open={isDrawerOpen}
                            footer={
                                <Flex align='center' justify='flex-end' gap={16}>
                                    <Button onClick={onCloseResponseDrawer}>Cancel</Button>
                                    <Button
                                        type='primary'
                                        onClick={() => {
                                            actionForm.submit();
                                        }}
                                        danger={actionButtonName === 'Reject'}
                                    >
                                        {actionButtonName}
                                    </Button>
                                </Flex>
                            }
                        >
                            <>
                                <Form
                                    onFinish={onFinish}
                                    form={actionForm}
                                    layout="vertical"
                                >
                                    {!needMoreInfoFieldsVisibility && (
                                        <Text
                                            type="secondary"
                                            disabled={needMoreInfoFieldsVisibility}
                                        >
                                            If you need more info, select level or user and add your comment and request details:
                                            <br />
                                            <br />
                                        </Text>
                                    )}
                                    {needMoreInfoFieldsVisibility == false && (
                                        <Form.Item
                                            label="Select Level"
                                            name="targetApproverEntryId"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Select a User',
                                                }
                                            ]}
                                        >
                                            <Select
                                                placeholder="Select a level or user"
                                                options={levelList}
                                            />
                                        </Form.Item>
                                    )}


                                    <Form.Item
                                        label="Add Comment"
                                        name="comment"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Add a Comment',
                                            }
                                        ]}>
                                        <TextArea rows={3} placeholder="Enter your comment here" />
                                    </Form.Item>
                                </Form>
                            </>
                            {needMoreInfoFieldsVisibility && (
                                <div>
                                    <Dragger {...props2} fileList={fileList2}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <Text type='secondary' className="ant-upload-text">Click or drag file to this area to upload</Text>
                                        <br />
                                        <Text type='secondary' className="ant-upload-hint">
                                            Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                                            banned files.
                                        </Text>
                                    </Dragger>
                                </div>
                            )
                            }
                        </Drawer>
                    </>
                </>
            )}
        </>
    )
}
